// Sdílená cache Audio elementů pro zvuky přehrávané asynchronně z Mercure
// push callbacku, ne přímo z uživatelova kliknutí (PvP "yeat-bell"/"boxing-bell",
// obecná notifikace v App.vue). Desktopová "unlockAudio" (App.vue mounted())
// odemyká autoplay podle "user activation" napříč stránkou, ale mobilní
// WebKit (iOS Safari, i nainstalovaná PWA) váže odemčení na KONKRÉTNÍ
// <audio> element, se kterým gesto proběhlo - `new Audio(...)` vytvořený
// později uvnitř push callbacku je i po prvním doteku pořád zablokovaný
// nový element. Řešení: pro každý zvuk existuje jen jeden, jednou
// vytvořený element (stejný vzor jako MusicPlayer.vue audioCache), který se
// při prvním gestu "odemkne" a pak se pořád dokola jen znovu přehrává.
const soundContext = require.context('@/assets/sounds', false, /\.(mp3|wav)$/);
const cache = {};

function getCachedAudio(file) {
    if (!cache[file]) {
        cache[file] = new Audio(soundContext('./' + file));
    }
    return cache[file];
}

export function unlockNotificationSounds(files) {
    files.forEach((file) => {
        const audio = getCachedAudio(file);
        audio.muted = true;
        audio.play().then(() => {
            audio.pause();
            audio.currentTime = 0;
            audio.muted = false;
        }).catch(() => {
            audio.muted = false;
        });
    });
}

export function playNotificationSound(file, volume) {
    const audio = getCachedAudio(file);
    audio.volume = volume;
    audio.currentTime = 0;
    audio.play().catch((e) => console.warn('Notification sound blocked:', file, e));
}
